export const ANIMATION_TIME = '.15s';
